"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var SmallDescriptionText_1 = __importDefault(require("atomicComponents/atoms/Text/SmallDescriptionText"));
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var single_1 = require("utils/selectors/single");
var hooks_1 = require("../Modals/CreateCustomerModal/hooks");
var AccountingFirmInfo = function () {
    var _a;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var mainCompany = profile.mainCompanyId && ((_a = profile === null || profile === void 0 ? void 0 : profile.companyData) === null || _a === void 0 ? void 0 : _a[profile.mainCompanyId]);
    var _b = __read((0, hooks_1.useBackToMyFirm)(), 1), backToMyFirm = _b[0];
    if (!mainCompany) {
        return null;
    }
    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ onClick: backToMyFirm, display: "flex", alignItems: "center", py: 1, pl: 4, pr: 2 }, { children: [(0, jsx_runtime_1.jsx)(ProfileAvatar_1.default, { profile: mainCompany }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ pl: 1.5, overflow: "hidden" }, { children: [(0, jsx_runtime_1.jsx)(PopupText_1.default, { message: (0, jsx_runtime_1.jsx)("strong", { children: mainCompany.name }), variant: "dark" }), (0, jsx_runtime_1.jsx)(SmallDescriptionText_1.default, { children: "Your accounting firm" })] }))] })));
};
exports.default = AccountingFirmInfo;
